<template>
  <div class="text-center">
    <v-dialog
      v-model="isIdle"
      width="500"
    >
      <v-card>
        <v-card-title>
          A munkamenet hamarosan lejár!
        </v-card-title>
        <v-card-text>
          <div class="p-3">
            <p>30 perce nem használtad az alkalmazást.</p>
            <p>{{ time/1000 }} másodperc múlva az alkalmazás kilép</p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import router from '@/router'

  export default {
    name: 'ModalIdle',
    data () {
      return {
        time: 40000,
      }
    },
    computed: {
      isIdle () {
        return this.$store.state.idleVue.isIdle
      },
    },
    created () {
      const timerId = setInterval(() => {
        this.time -= 1000
        if (!this.$store.state.idleVue.isIdle) clearInterval(timerId)

        if (this.time < 1) {
          clearInterval(timerId)
          router.push('/logout').catch(() => {})
          // Your logout function should be over here
        }
      }, 1000)
    },
  }
</script>
